import type { SwitchOption } from '../config';

/**
 * The <option>s of a report switcher: running campaigns first, archived ones
 * below, each group under its own heading (an <optgroup>) in the dashboard's
 * language. An empty group is left out. `value` picks what an option submits —
 * the route (the dashboard headers) or the report id (the generic header).
 */
export function ReportOptions({
  options,
  labels,
  value = (o) => o.path,
}: {
  options: ReadonlyArray<SwitchOption>;
  labels: { active: string; archived: string };
  value?: (o: SwitchOption) => string;
}) {
  const groups = [
    { label: labels.active, items: options.filter((o) => !o.archived) },
    { label: labels.archived, items: options.filter((o) => o.archived) },
  ].filter((g) => g.items.length > 0);
  return (
    <>
      {groups.map((g) => (
        <optgroup key={g.label} label={g.label}>
          {g.items.map((o) => (
            <option key={o.reportId} value={value(o)}>
              {o.label}
            </option>
          ))}
        </optgroup>
      ))}
    </>
  );
}
